import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 265520130 },
  { year: 2011, value: 263547165 },
  { year: 2012, value: 343261726 },
  { year: 2013, value: 366995988 },
  { year: 2014, value: 406216754 },
  { year: 2015, value: 415971993 },
  { year: 2016, value: 423883600 },
  { year: 2017, value: 403472019 },
  { year: 2018, value: 340366396 },
  { year: 2019, value: 325946580 },
  { year: 2020, value: 282195863 },
  { year: 2021, value: 361488287 },
  { year: 2022, value: 326294122 },
  { year: 2023, value: 348742398 },
  { year: 2024, value: 424649476 },
  { year: 2025, value: 434143882 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er Término)' },
  { year: 2017, label: 'JOH Anuncia Reelección' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageIndustriaAnio() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/origen-inversion-2')}>
            &#8592; Origen
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Valor de la Industria</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria total &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/industria-anio-domestica')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageIndustriaAnio;
